export const PRODUCT_ONE = 105;
export const PRODUCT_PRICING = 101;
export const PRODUCT_ENTRY = 106;
export const PRODUCT_DISPENSING_MANUAL = 104;
export const PRODUCT_DISPENSING = 102;
export const PRODUCT_PLUS = 103;
export const DELETED_LICENSE = 116;
export const INVALID_LICENSE = 118;

export const STATUS_ERROR = -1;
export const STATUS_UNKNOWN = 0;
export const STATUS_VALID_UNLIMITED_LICENSE = 1;
export const STATUS_VALID_LEASED_LICENSE = 2;
export const STATUS_VALID_PROLONGATED_LICENSE = 3;

export const OK = 0;

export const NOT_LICENSED = 1;
export const INVALID_LICENSE_FILE = 2;
export const LICENSE_FILE_CORRUPTED = 3;
export const INVALID_KEY = 4;
export const CANNOT_WRITE_LICENSE = 5;

export const LICENSE_EXPIRED = 10;
export const LICENSE_REVOKED = 11;
export const LICENSE_PROLONGATION_NEEDED = 12;

export const INVALID_PRODUCT = 20;
export const FEATURE_NOT_AUTORIZED = 21;
export const VERSION_TOO_NEW = 22;

export const COMPUTER_ID_MISMATCH = 30;
export const SYSTEM_INFO_MISMATCH = 31;
export const CPU_MEMORY_MISMATCH = 32;
export const DISKS_MISMATCH = 33;
export const NETWORK_MISMATCH = 34;

export const VM_NOT_ALLOWED = 40;

export const COMPUTER_BACKDATED = 50;

export const WEB_API_CONNECTION_ERROR = 500;
export const WEB_API_INTERNAL_ERROR = 501;
export const WEB_API_INVALID_USER = 502;
export const WEB_API_NO_LICENSE_AVAILABLE = 503;

export const UNKNOWN_ERROR = 999;

export const LICENSE_UPDATE_RESULT_LICENSE_VALID_NO_UPDATE_NEEDED = "license_valid_no_update_needed";
export const LICENSE_UPDATE_RESULT_LICENSE_UPDATED = "license_updated";
